module.exports = __webpack_public_path__ + "img/homeIcon.2b665f3d.svg";